// Chakra imports
import { DeleteIcon } from '@chakra-ui/icons';
import { Badge, Box, Flex, IconButton, SimpleGrid, useToast } from '@chakra-ui/react';

import { useMemo } from 'react';
import { deleteClient, findAllClients } from 'services/api.service';
import { Column } from 'react-table';
import { DateTime } from 'luxon';
import TableComponent from 'components/TableComponent';
import CreateClient from './components/CreateClient';
import EditClient from './components/EditClient';
import { queryClient } from 'index';

export default function Clients() {
  const toast = useToast();
  const columns = useMemo(
    () =>
      [
        {
          Header: 'Nome',
          accessor: 'name',
        },
        {
          Header: 'CPF',
          accessor: 'document',
        },
        {
          Header: 'Email',
          accessor: 'email',
        },
        {
          Header: 'Telefone',
          accessor: 'phone',
        },
        {
          Header: 'Status',
          accessor: 'status',
          Cell: ({ value }: { value: string }) => {
            return value === 'ACTIVE' ? (
              <Badge colorScheme="green">Ativo</Badge>
            ) : (
              <Badge colorScheme="red">Inativo</Badge>
            );
          },
        },

        {
          accessor: 'createdAt',
          Header: 'Data',
          Cell: ({ value }) => {
            return DateTime.fromISO(value).toFormat('dd/MM/yyyy HH:mm:ss');
          },
        },
        {
          Header: 'Ações',
          accessor: 'actions',
        },
      ] as Column[],
    [],
  );

  const handleDelete = async (clientId: string) => {
    if (!window.confirm('Tem certeza que deseja remover este cliente?')) {
      return;
    }

    try {
      await deleteClient(clientId);
      await queryClient.invalidateQueries({
        queryKey: ['findAllClients'],
      });
      toast({
        title: 'Sucesso',
        description: 'Cliente removido com sucesso',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (err: any) {
      toast({
        title: 'Erro',
        description: err?.response?.data?.message || 'Erro ao remover cliente',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const actions = (row: any) => (
    <Flex align="center" justify="flex-start" w="100%" gap={2}>
      <EditClient clientId={row.id} />
      <IconButton
        aria-label="Remover cliente"
        icon={<DeleteIcon />}
        size="sm"
        rounded="sm"
        variant="outline"
        colorScheme="red"
        onClick={() => handleDelete(row.id)}
      />
    </Flex>
  );

  // Chakra Color Mode
  return (
    <Box>
      <SimpleGrid mb="20px" columns={{ sm: 1 }} spacing={{ base: '20px', xl: '20px' }}>
        <TableComponent
          label="Clientes Cadastrados"
          columnsData={columns}
          right={<CreateClient />}
          queryFn={findAllClients}
          queryKey="findAllClients"
          actions={actions}
        />
      </SimpleGrid>
    </Box>
  );
}
